import {QueryGetExercises} from '../../../../services';
import {
  Exercise,
  ExerciseSearchResult,
  ExerciseFilterOptions,
  SelectedExerciseData,
} from './ExerciseLibraryModal.type';

export class ExerciseLibraryModalService {
  static async searchExercises(
    page: number = 1,
    searchTerm: string = '',
    filters: ExerciseFilterOptions = {},
  ): Promise<ExerciseSearchResult> {
    try {
      const {data} = await QueryGetExercises(page, searchTerm);

      return {
        list: data.list.map((exercise: any) => ({
          id: exercise.id,
          name: exercise.name,
          description: exercise.description,
          image: exercise.image,
          animatedImage: exercise.animatedImage,
          muscleGroups: exercise.muscleGroups || [],
          equipment: exercise.equipment || [],
        })),
        totalPages: data.totalPages,
        currentPage: page,
        totalCount: data.totalCount || 0,
      };
    } catch (error) {
      console.error('Error searching exercises:', error);
      throw error;
    }
  }

  static validateExerciseData(exerciseData: SelectedExerciseData): boolean {
    const hasExercise = exerciseData?.exercise;
    const hasValidId = exerciseData?.exercise?.id && 
                      String(exerciseData.exercise.id).trim() !== '';
    const hasValidName = exerciseData?.exercise?.name && 
                        String(exerciseData.exercise.name).trim() !== '';
    
    return !!(hasExercise && hasValidId && hasValidName);
  }

  static createExerciseWorkoutData(exerciseData: SelectedExerciseData) {
    return {
      id: '',
      tempId: new Date().getTime(),
      exerciseId: exerciseData.exercise.id,
      exercise: {
        label: exerciseData.exercise.name,
        value: exerciseData.exercise.id,
        animatedImage: exerciseData.exercise.animatedImage,
        image: exerciseData.exercise.image,
      },
      series: exerciseData.series || '',
      reps: exerciseData.reps || '',
      weight: exerciseData.weight || '',
      time: exerciseData.time || '',
      restTime: exerciseData.restTime || '',
      notes: exerciseData.notes || '',
    };
  }

  static getExerciseImageUrl(exercise: Exercise): string | null {
    if (exercise.animatedImage?.uriOriginal) {
      return exercise.animatedImage.uriOriginal;
    }
    if (exercise.animatedImage?.uri) {
      return exercise.animatedImage.uri;
    }
    if (exercise.image?.uri) {
      return exercise.image.uri;
    }
    if (exercise.image?.uriOriginal) {
      return exercise.image.uriOriginal;
    }
    return null;
  }
}
